import api from "@core/plugins/api";
import { EtabProfileModel } from "@core/models";
import { EtabProfileDTO } from "@core/dto";

const getProfileUrl = () => `/api/et/profil`;
const getProfilById = (id) => `/api/etabbizdev/etab/${id}`;
const savePhotoUrl = () => `/api/et/photo`;
const updateProfileUrl = () => `/api/et/profil`;
const getStatusUrl = () => `/subscription-highlight/et/my-status`;

export class EtabProfileService {
  static async get() {
    try {
      const response = await api.private.get(getProfileUrl());
      const profile = response && response.data;
      return profile;
    } catch (error) {
      throw error;
    }
  }

  static async getEtabById(id) {
    try {
      const response = await api.private.get(getProfilById(id));
      const profil = response && response.data.etab;
      return profil;
    } catch (error) {
      throw error;
    }
  }

  static async getEtabId() {
    try {
      const profile = await EtabProfileService.get();
      const model = new EtabProfileModel(profile);
      return model.getId();
    } catch (error) {
      throw error;
    }
  }

  static async getEtabName() {
    try {
      const profile = await EtabProfileService.get();
      const model = new EtabProfileModel(profile);
      return model.getEtabName();
    } catch (error) {
      throw error;
    }
  }

  static async getSubscriptionStatus() {
    try {
      const { data } = await api.private.get(getStatusUrl());
      return data?.status;
    } catch (error) {
      throw error;
    }
  }

  static async isBillingAE() {
    try {
      const profile = await EtabProfileService.get();
      const model = new EtabProfileModel(profile);
      return model.isBillingAE();
    } catch (error) {
      throw error;
    }
  }

  static async isAllowedAE() {
    try {
      const profile = await EtabProfileService.get();
      const model = new EtabProfileModel(profile);
      return model.isAllowedAE();
    } catch (error) {
      throw error;
    }
  }

  static async hasIban() {
    try {
      const profile = await EtabProfileService.get();
      const model = new EtabProfileModel(profile);
      return model.hasIban();
    } catch (error) {
      throw error;
    }
  }

  static async hasActiveSubscription() {
    try {
      const profile = await EtabProfileService.get();
      const model = new EtabProfileModel(profile);
      return model.hasActiveSubscription();
    } catch (error) {
      throw error;
    }
  }

  static async savePhoto({ photo }) {
    try {
      if (photo) {
        return api.private.post(savePhotoUrl(), photo);
      }
      throw new Error("Data not provided");
    } catch (error) {
      throw error;
    }
  }

  static async updateAdditionalInfo({ profile }) {
    try {
      if (profile) {
        const dto = new EtabProfileDTO(profile);
        const data = dto.prepareUpdateAdditionalInfoData();
        return api.private.post(updateProfileUrl(), data);
      }
      throw new Error("Data not provided");
    } catch (error) {
      throw error;
    }
  }

  static async update({ profile }) {
    try {
      if (profile) {
        const dto = new EtabProfileDTO(profile);
        const data = dto.prepareUpdateData();
        const response = await api.private.post(updateProfileUrl(), data);
        return response && response.data;
      }
      throw new Error("Data not provided");
    } catch (error) {
      throw error;
    }
  }
}
